import { render, staticRenderFns } from "./RashodnayaNakladnayaTable.vue?vue&type=template&id=5f33d31e&scoped=true&"
import script from "./RashodnayaNakladnayaTable.vue?vue&type=script&lang=js&"
export * from "./RashodnayaNakladnayaTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f33d31e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!/home/vagrant/interfaces/online/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDataTable } from 'vuetify/lib'
installComponents(component, {VDataTable})
